import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const appLayoutDefaultVariants = {
  "isExtendableHeight": false
}
const appLayoutCompoundVariants = []

const appLayoutSlotNames = [
  [
    "root",
    "AppLayout__root"
  ],
  [
    "sticky",
    "AppLayout__sticky"
  ],
  [
    "banner",
    "AppLayout__banner"
  ],
  [
    "header",
    "AppLayout__header"
  ],
  [
    "sidebar",
    "AppLayout__sidebar"
  ],
  [
    "main",
    "AppLayout__main"
  ]
]
const appLayoutSlotFns = /* @__PURE__ */ appLayoutSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, appLayoutDefaultVariants, getSlotCompoundVariant(appLayoutCompoundVariants, slotName))])

const appLayoutFn = memo((props = {}) => {
  return Object.fromEntries(appLayoutSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const appLayoutVariantKeys = [
  "isExtendableHeight"
]
const getVariantProps = (variants) => ({ ...appLayoutDefaultVariants, ...compact(variants) })

export const appLayout = /* @__PURE__ */ Object.assign(appLayoutFn, {
  __recipe__: false,
  __name__: 'appLayout',
  raw: (props) => props,
  variantKeys: appLayoutVariantKeys,
  variantMap: {
  "isExtendableHeight": [
    "true"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, appLayoutVariantKeys)
  },
  getVariantProps
})